import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Table,
  Container,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { useGeolocated } from "react-geolocated";
import { saveAs } from "file-saver";
import Card from "../../../components/Card";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import SignatureModal from "../../../components/SignatureComponent";
const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  const day = d.getDate().toString().padStart(2, "0");
  const month = d.toLocaleString("default", { month: "long" });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const BlogDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // console.log(location);

  const course =
    JSON.parse(localStorage.getItem("course")) ?? location.state?.course;
  // console.log(JSON.parse(localStorage.getItem("course")));

  console.log(course, "pressings");

  const courseData = course?.student;
  // console.log(course, "course details at blogdetails ...........");
  // console.log(course?.student, "course details at blogdetails ...........");

  const [searchTerm, setSearchTerm] = useState("");
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [scores, setScores] = useState([]); // Example: 70% score
  const [attendanceProgress, setAttendanceProgress] = useState(0); // Example: 85% attendance
  const [data, setData] = useState({});
  const [resources, setResources] = useState([]);
  const [days, setDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState("");

  const [lesson_plans, setLesson_plans] = useState([]);
  const [venue, setVenue] = useState("");
  const [timing, setTiming] = useState("");
  const [start_time, setStart_time] = useState("");
  const [end_time, setEnd_time] = useState("");
  const [trainingEndDate, setTrainingEndDate] = useState("");
  const [trainingStartDate, setTrainingStartDate] = useState("");
  const [dates, setDates] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [errors, setErrors] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isResourseLoading, setIsResourceLoading] = useState(true);
  const [isLessonLoading, setIsLessonLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [signature, setSignature] = useState(null);

  useEffect(() => {
    setTimeout(() => setPageLoading(false), 2000);
  }, []);

  const handleChange = (event) => {
    setSelectedDay(event.target.value);
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  // console.log(trainingStartDate, "trainingStartDate");
  // console.log(trainingEndDate, "trainingEndDate");

  const [uploadedData, setuploadedData] = useState({
    school_code: course?.school_code,
    student_id: courseData?.student_id,
    class: courseData?.class,
    section: courseData?.section,
    subject: course?.school_name,
    title: "",
    due_date: "",
    start_time: start_time,
    end_time: end_time,
    given_by: courseData?.student_name,
    file_path: "",
    level: courseData?.level,
    combination_code: courseData?.combination_code,
  });
  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });

  const latitude =
    isGeolocationAvailable && isGeolocationEnabled && coords
      ? coords.latitude
      : "";
  const longitude =
    isGeolocationAvailable && isGeolocationEnabled && coords
      ? coords.longitude
      : "";

  const now = new Date(); // Get current date and time

  const day = now.getDate(); // Day of the month (1-31)
  const month = now.getMonth() + 1; // Month (0-11) + 1 to make it 1-12
  const year = now.getFullYear(); // Year (e.g., 2025)

  const date = now.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  // console.log(now, " <- Local date string");
  // console.log("Day:", day);
  // console.log("Month:", month);
  // console.log("Year:", year);
  // console.log("ISO Date:", date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let start = null;
  let end = null;

  if (trainingStartDate && !isNaN(new Date(trainingStartDate))) {
    start = new Date(trainingStartDate);
    start.setHours(0, 0, 0, 0);
  }

  if (trainingEndDate && !isNaN(new Date(trainingEndDate))) {
    end = new Date(trainingEndDate);
    end.setHours(0, 0, 0, 0);
  }

  const files = [
    {
      id: 1,
      name: "Class Presentation",
      date: "15 March, 2025",
      time: "05:30 AM",
      author: "Vikas Kumar",
    },
    {
      id: 2,
      name: "Teaching Delivery Plan",
      date: "16 March, 2025",
      time: "07:30 AM",
      author: "Vikas Kumar",
    },
    {
      id: 3,
      name: "Learning Outcome",
      date: "18 March, 2025",
      time: "08:30 AM",
      author: "Vikas Kumar",
    },
    ,
    {
      id: 4,
      name: "Notes",
      date: "18 March, 2025",
      time: "08:30 AM",
      author: "Ramesh Kumar",
    },
  ];
  // Filter files based on search term
  const filteredFiles =
    data?.resources?.filter(
      (file) =>
        file.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        file.author.toLowerCase().includes(searchTerm.toLowerCase()),
    ) || [];

  // const getCourseDetails = async () => {
  //   const response = await axios.post(webServiceUrl.enrolled_courses_detials, {
  //     courseId: 1,
  //   });

  //   console.log(response.data, "from getCourseDetails");
  //   setData(response.data);
  // };

  const getResources = async () => {
    try {
      setIsResourceLoading(true);
      const response = await axios.post(webServiceUrl.resources, {
        school_code: course?.school_code,
        class_name: courseData?.class,
        section: courseData?.section,
        level: courseData?.level,
        combination_code: courseData?.combination_code,
      });

      console.log(response?.data?.data, "from getResources");
      setResources(response?.data?.data ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => setIsResourceLoading(false), 1500);
    }
  };

  const getAttendence = async () => {
    try {
      const response = await axios.post(webServiceUrl.show_attendence, {
        school_code: course?.school_code,
        student_id: courseData?.student_id,
      });

      console.log(response?.data, "from getAttendence");
      setAttendanceProgress(response?.data?.percentage ?? 0);
    } catch (error) {
      console.log(error);
    }
  };
  const getScore = async () => {
    try {
      const response = await axios.post(webServiceUrl.score, {
        school_code: course?.school_code,
        student_id: courseData?.student_id,
      });

      console.log(response?.data, "from getScore");
      setScores(response?.data?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const validateAssignmentData = (data) => {
    const newError = {};
    if (!data?.title) {
      newError.title = "title is required!";
    }
    if (!data?.file_path) {
      newError.file_path = "please upload a file!";
    }
    setErrors(newError);
    return Object.keys(newError)?.length === 0;
  };

  const uploadAssignments = async () => {
    // console.log(uploadedData);
    try {
      const isValid = validateAssignmentData(uploadedData);
      if (!isValid) return;

      setIsUploading(true);
      const formData = new FormData();
      Object.entries(uploadedData).forEach(([key, value]) => {
        if (key !== "file_path") {
          formData.append(key, value);
        } else {
          formData.append("assignment_file", value); // value should be the actual File object
        }
      });

      const response = await axios.post(
        webServiceUrl.upload_assignments,
        formData,
      );
      // console.log(response);
      if (response?.data?.success) {
        // console.log("//////////////////////");
        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        getResources();
        setShow2(false);
        setTimeout(() => setIsUploading(false), 1000);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error.response.data.message);

      toast.error(error.response.data.message);
    } finally {
      setTimeout(() => setIsUploading(false), 1500);
    }
  };

  const mark_attendence = async () => {
    if (!isGeolocationAvailable) {
      alert("Your browser does not support Geolocation");
    }
    if (!isGeolocationEnabled) {
      alert("Geolocation is not enabled");
    }

    try {
      const response = await axios.post(webServiceUrl.mark_attendence, {
        school_code: course?.school_code,
        student_id: courseData?.student_id,
        longitude: longitude,
        latitude: latitude,
        student_name: courseData?.student_name,
        day: day,
        month: month,
        year: year,
        academic_year: courseData?.academic_year,
        class: courseData?.class,
        section: courseData?.section,
        course_name: course?.school_name,
        level: courseData?.level,
        combination_code: courseData?.combination_code,
        period_start_on: start_time,
        period_end_on: end_time,
      });
      // console.log(response?.data?.message, "from mark_attendence");
      if (response?.data?.success) {
        // console.log("//////////////////////");

        toast.success(response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        getAttendence();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error.response.data.message);
      toast.error(error.response.data.message);
    }
  };

  const getDays = async () => {
    const response = await axios.post(webServiceUrl.getLessonPlanDays, {
      school_code: course?.school_code,
      class_name: courseData?.class,
      section: courseData?.section,
      level: courseData?.level,
      combination_code: courseData?.combination_code,
    });

    // console.log(response?.data?.data[0]);
    // console.log(response?.data?.data[response?.data?.data?.length - 1].day);

    const formatDate = (dateStr) => {
      const d = new Date(dateStr);
      const day = d.getDate().toString().padStart(2, "0");
      const month = d.toLocaleString("default", { month: "long" });
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const start = formatDate(response?.data?.data[0].day);
    const end = formatDate(
      response?.data?.data[response?.data?.data?.length - 1].day,
    );
    setDays(response?.data?.data);

    setTrainingStartDate(response?.data?.data[0].day);

    setTrainingEndDate(
      response?.data?.data[response?.data?.data?.length - 1].day,
    );
    setDates(`${start}-${end}`);
    setSelectedDay(response?.data?.data[0].day);
  };

  const getLessonPlans = async () => {
    try {
      setIsLessonLoading(true);
      const response = await axios.post(webServiceUrl.lesson_plan, {
        school_code: course?.school_code,
        class_name: courseData?.class,
        section: courseData?.section,
        level: courseData?.level,
        combination_code: courseData?.combination_code,
        planned_on: selectedDay,
      });

      // console.log(response?.data?.data, "from getLessonPlans");
      setLesson_plans(response?.data?.data ?? []);
      // console.log(response?.data?.data[0].planned_on);
      const formatDate = (dateStr) => {
        const d = new Date(dateStr);
        const day = d.getDate().toString().padStart(2, "0");
        const month = d.toLocaleString("default", { month: "long" });
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const data = response?.data?.data;
      const date = `${formatDate(data[0]?.planned_on)} - ${formatDate(data[data.length - 1]?.planned_on)}`;

      //  const date = `${new Date(
      //    response?.data?.data[0].planned_on
      //  ).toLocaleDateString()}-${new Date(
      //    response?.data?.data[response?.data?.data.length - 1].planned_on
      //  ).toLocaleDateString()}`;

      setVenue(response?.data?.data[0].venue ?? "");
      setStart_time(response?.data?.data[0].start_time ?? "");
      setEnd_time(
        response?.data?.data[response?.data?.data?.length - 1].end_time ?? "",
      );
      setTiming(
        `${response?.data?.data[0].start_time}-${response?.data?.data[0].end_time}` ??
          "",
      );
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => setIsLessonLoading(false), 1500);
    }
  };

  // useEffect(() => {
  //   getLessonPlans();
  // }, [selectedDay]);

  const downloadCertificate = async () => {
    setIsLoading(true);

    try {
      const response = await axios.post(
        webServiceUrl.download_pdf,
        {
          name: courseData?.student_name,
          previous_school: courseData?.previous_school,
          academic_year: courseData?.academic_year,
          course: course?.school_name,
          start_date: start_time,
          end_date: end_time,
        },
        {
          responseType: "blob", // 👈 tells axios to expect binary data
        },
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      saveAs(blob, "certificate.pdf");
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsLoading(false); // Hide loading GIF after done
    }
  };

  useEffect(() => {
    // getResources();
    // getLessonPlans();
    // getScore();
    // getAttendence();
    // getDays();
  }, []);

  if (pageLoading) {
    return (
      <>
        <div
          className="d-flex justify-content-center "
          style={{ height: "85vh", paddingTop: "15vh" }}
        >
          <Oval
            height="50"
            width="50"
            color="#4fa94d"
            secondaryColor="#4fa94d"
          />
        </div>
      </>
    );
  }

  return (
    <>
      <ToastContainer />
      <div id="content-page" className="content-inner">
        <Container fluid>
          <SignatureModal
            isOpen={open}
            onClose={() => setOpen(false)}
            onSave={(data) => setSignature(data)} // 🔥 receive from modal
            width={500}
            height={200}
          />
          <Row className="justify-content-center">
            <Col lg="12">
              <Card className="shadow-sm border-0 rounded-3 overflow-hidden px-2">
                <Card.Body className="px-2 py-5 p-md-4">
                  {/* Image Section */}
                  {/* <div className="image-block mb-3">
                    <Image
                      src={robot}
                      className="img-fluid rounded w-100"
                      alt="blog-img"
                      style={{ height: "280px", objectFit: "cover" }}
                    />
                  </div> */}

                  <Row className="align-items-start">
                    {/* Content Section */}
                    {/* <Col sm="12" md="7">
                      <div className=" d-flex flex-column gap-2">
                        <p className="fw-bold enrolled-courseHead">
                          {course?.school_name}
                        </p>
                        <p className="text-muted mb-2 fw-semibold">
                          📅 {dates} | 🕗 {start_time.slice(0, 5)}-
                          {end_time.slice(0, 5)}
                        </p>
                        <p className="text-muted mb-0 fw-semibold">
                          📍 Venue: {venue}
                        </p>
                      </div>
                    </Col> */}
                    {/* Attendance Section */}
                    {/* <Col
                      sm="12"
                      md="5"
                      className="mt-4 d-flex justify-content-md-end"
                    >
                      <div style={{ width: "100%", maxWidth: "300px" }}>
                        <h4 className="card-title mb-2">Attendance:</h4>
                        <ProgressBar
                          now={attendanceProgress}
                          label={`${attendanceProgress}%`}
                          // variant={Number(attendanceProgress) < 75 ? 'danger' : 'success'}
                          className={Number(attendanceProgress) < 75 ? "custom-progress" : "custom-progress1"}
                        />

                      </div>
                    </Col> */}
                  </Row>

                  {/* Action Buttons Section */}
                  <div className="mt-4 mt-sm-2">
                    {/* Scrollable on small screens only */}
                    <div
                      className="d-sm-none"
                      style={{
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                    >
                      <div className="d-inline-flex gap-2 mb-2">
                        {start && end && today >= start && today <= end && (
                          <Button onClick={mark_attendence}>
                            Mark Attendance
                          </Button>
                        )}

                        {/* {end && today > end && (
                          <Button
                            className="btn btn-primary px-3 py-2 text-nowrap"
                            onClick={downloadCertificate}
                            disabled={isLoading}
                          >
                            {isLoading && (
                              <img
                                src="https://upload.wikimedia.org/wikipedia/commons/a/ad/YouTube_loading_symbol_3_%28transparent%29.gif"
                                alt="Loading..."
                                style={{ width: 24, height: 24, marginRight: 8 }}
                              />
                            )}{" "}
                            Download Certificate
                          </Button>
                        )} */}
                        <Link
                          to={`/dashboard/program/send-query/${course?.school_code}`}
                          state={{ course }}
                          className="text-decoration-none"
                        >
                          <Button className="btn btn-primary px-3 py-2 text-nowrap">
                            Send Query
                          </Button>
                        </Link>

                        {/* <Link
                          to={today > end ? `/post-feedback/${course?.school_code}` : `/pre-feedback/${course?.school_code}`}
                          className="text-decoration-none"
                        >
                          <Button className="btn btn-primary px-3 py-2 text-nowrap">
                            Send {today > end ? 'Post-Training' : 'Pre-Training'} Feedback
                          </Button>
                        </Link> */}

                        {today >= end && (
                          <Link
                            to={`/post-feedback/${course?.school_code}`}
                            className="text-decoration-none"
                          >
                            <Button className="btn btn-primary px-3 py-2 text-nowrap">
                              Send Post-Training Feedback
                            </Button>
                          </Link>
                        )}
                      </div>
                    </div>

                    {/* ===== 5 TRAINING STEPS SECTION - ADD AFTER FIRST </Row> (course header card closing) ===== */}
                    {/* ===== 5 TRAINING STEPS SECTION ===== */}
                    {/* ===== 7 TRAINING STEPS SECTION ===== */}
                    <Row className="justify-content-center mt-3">
                      <Col lg="12">
                        <Card className="shadow-sm border-0 rounded-3 px-2">
                          <Card.Body className="px-2 py-4 p-md-4">
                            {/* <h4
                              className="card-title mb-3"
                              style={{ textDecoration: "underline" }}
                            >
                              Candidate Steps
                            </h4> */}

                            <div className="row g-3">
                              {/* Step 1 - Pre-Training Feedback */}
                              <Link
                                to={`/dashboard/program/send-query/${course?.school_code}`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      1
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 1
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Send Query
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      Share your expectations and prior
                                      knowledge before training begins.
                                    </div>
                                    <a
                                      href="https://docs.google.com/forms/u/0/d/1fXJXrElIXgOUSCOXAiEMGu7vcALF_5a8ZXIrHOVPHuM/preview?edit_requested=true"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      View
                                    </a>
                                  </div>
                                </div>
                              </Link>

                              {/* Step 2 - TOP */}
                              <Link
                                to={`/dashboard/blog/Training_observation_plan_Top`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      2
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 2
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Training observation plan (TOP)
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      Complete your observation plan during the
                                      training program.
                                    </div>
                                    <a
                                      href="https://docs.google.com/forms/d/1pzBJOJDhHzT7Zc4PoFtEtIaInMbPqPouOUMRQNabgiw/preview?edit_requested=true"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      Fill Form
                                    </a>
                                  </div>
                                </div>
                              </Link>

                              {/* Step 3 - Evaluation TOP */}
                              <Link
                                to={`/dashboard/blog/Evalution`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      3
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 3
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Evaluation TOP
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      Evaluator reviews and scores your TOP
                                      after the training session.
                                    </div>
                                    <a
                                      href="https://docs.google.com/forms/d/1XE2WiyTZs7bVTgGFsQqyG23R8y6kubnU2yblnxLKNoM/edit#responses"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      Fill Form
                                    </a>
                                  </div>
                                </div>
                              </Link>
                              {/* Step 4 - Post-Training Feedback */}
                              {/* <Link
                                to={`/dashboard/blog/Post_Training_Feedback`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      4
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 4
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Post-training feedback
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      Share your experience and learnings after
                                      completing the training.
                                    </div>
                                    <a
                                      href="https://docs.google.com/forms/d/1nkRC-8MT2pnqNPV1B8hez2_ydqy-gEVqfbTuq2QUJr4/preview?edit_requested=true"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      Fill Form
                                    </a>
                                  </div>
                                </div>
                              </Link> */}

                              {/* Step 5 - Online Registration */}
                              {/* <Link
                                to={`/dashboard/blog/online-reg`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      5
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 5
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Online registration
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      Complete your online registration form to
                                      finalize enrollment.
                                    </div>
                                    <a
                                      href="https://docs.google.com/forms/d/1e60J7BXbAN1RXMcJLUc2BEll1YiAdcUdphbsHoYwWok/preview?edit_requested=true"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      Fill Form
                                    </a>
                                  </div>
                                </div>
                              </Link> */}

                              {/* Step 6 - Food Feedback */}
                              {/* <Link
                                to={`/dashboard/blog/FoodFeedbackForm`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      6
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 6
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Food feedback
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      Share your feedback about the food and
                                      catering arrangements during the training.
                                    </div>
                                    <a
                                      href="#"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      Fill Form
                                    </a>
                                  </div>
                                </div>
                              </Link> */}

                              {/* Step 7 - Gallery */}
                              <Link
                                to={`/dashboard/blog/Gallery`}
                                state={{ course }}
                                className="col-12 col-sm-6 col-xl-4"
                              >
                                <div>
                                  <div
                                    style={{
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      background: "#fff",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: "#2e7d32",
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "700",
                                        fontSize: "13px",
                                      }}
                                    >
                                      4
                                    </div>
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "10px",
                                          color: "#bbb",
                                          marginBottom: "2px",
                                        }}
                                      >
                                        Step 4
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#222",
                                        }}
                                      >
                                        Gallery
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        lineHeight: "1.5",
                                        flex: 1,
                                      }}
                                    >
                                      View and upload photos from the training
                                      program sessions.
                                    </div>
                                    <a
                                      href="#"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        padding: "6px 14px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        border: "1.5px solid #2e7d32",
                                        color: "#fff",
                                        background: "#2e7d32",
                                        textDecoration: "none",
                                        width: "fit-content",
                                      }}
                                    >
                                      View Gallery
                                    </a>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    {/* ===== END 7 TRAINING STEPS SECTION ===== */}
                    {/* ===== END 5 TRAINING STEPS SECTION ===== */}
                    {/* ===== END 5 TRAINING STEPS SECTION ===== */}
                    {/* Right-aligned on medium and large screens */}
                    <div className="d-none d-sm-flex justify-content-end gap-2 gap-sm-4 mt-4">
                      {/* {start && end && today >= start && today <= end && (
                        <Button onClick={mark_attendence}>Mark Attendance</Button>
                      )} */}

                      {/* {end && today > end && (
                        <Button
                          className="btn btn-primary px-3 py-2 text-nowrap"
                          onClick={downloadCertificate}
                          disabled={isLoading}
                        >
                          {isLoading && (
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/a/ad/YouTube_loading_symbol_3_%28transparent%29.gif"
                              alt="Loading..."
                              style={{ width: 24, height: 24, marginRight: 8 }}
                            />
                          )}{" "}
                          Download Certificate
                        </Button>
                      )} */}
                      {/* <Link
                        to={`/dashboard/program/send-query/${course?.school_code}`}
                        state={{ course }}
                        className="text-decoration-none"
                      >
                        <Button className="btn btn-primary px-3 py-2 text-nowrap">
                          Send Query
                        </Button>
                      </Link>

                      {today >= end && (
                        <Link
                          to={`/post-feedback/${course?.school_code}`}
                          className="text-decoration-none"
                        >
                          <Button className="btn btn-primary px-3 py-2 text-nowrap">
                            Send Post-Training Feedback
                          </Button>
                        </Link>
                      )} */}

                      {/* <Link
                        to={today > end ? `/post-feedback/${course?.school_code}` : `/pre-feedback/${course?.school_code}`}
                        className="text-decoration-none"
                      >
                        <Button className="btn btn-primary px-3 py-2 text-nowrap">
                          Send {today > end ? 'Post-Training' : 'Pre-Training'} Feedback
                        </Button>
                      </Link> */}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogDetail;
